import { NOTIFICATIONS } from '../../../endpoints'
import { apiPrivate } from '../../../api'
import types from '../types/activity'
import { push } from 'react-router-redux'
import { endpoint as endpointText } from '../../../common/text'
import { ApiError } from '../schemas'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class activity {
  static fetch() {
    return function (dispatch, getState) {

      dispatch({ type: types.FETCH })

      return apiPrivate.get(NOTIFICATIONS + '/notifications/all')
        .then(response => {

          const data = response.data.description
          dispatch(activity.fetchSuccess(data.notifications))

        }, error => {

          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(activity.fetchFail(message))
              return
            }
            const response = new ApiError(error.response.data)
            message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(activity.fetchFail(message))
        })

    }
  }

  static fetchSuccess(notifications) {
    return {
      type: types.FETCH_SUCCESS,
      payload: {
        notifications,
      },
    }
  }

  static fetchFail(error) {
    return {
      type: types.FETCH_FAIL,
      payload: {
        error,
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/sections/activity/actions/activity.js